import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';

const GET_CONDITION = gql`
    query GetCondition($type: ConditionType!) {
        condition(type: $type) {
            uuid
            type
            publishedVersionNumber
            versions {
                uuid
                contentFr
                contentEn
                versionNumber
                createdAt
                publishedAt
                updatedAt
            }
        }
    }
`;

const useCondition = (type) => {
    const {loading, error, data, refetch} = useQuery(GET_CONDITION, {
        variables: {type},
        skip: !type,
        fetchPolicy: 'network-only',
    });

    return {
        loading,
        error,
        condition: data?.condition,
        refetch,
    };
};

export default useCondition;